import { CloudUploadOutlined, DeleteOutlined } from '@ant-design/icons';
import { Alert, Button, Card, Image } from 'antd';
import React, { useState } from 'react';
import { useUploadFile } from '../../zustand/store';
import { Wrapper } from './styles';
import { BASE_URL } from '../../constants/link';
const getBase64 = (file) =>
    new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
    });
const UploadImg = ({ imgList, setImgList }) => {
    const uploadFile = useUploadFile();
    const [previewOpen, setPreviewOpen] = useState(false);
    const [previewImage, setPreviewImage] = useState('');
    // const [imgList, setImgList] = useState([]);


    return (
        <>
            <Wrapper>
                <Image.PreviewGroup>
                    {
                        imgList?.map(({ img, photo, main }, i) => (

                            <Card
                                key={i}
                                title={<Button type={main ? "primary" : ""} block
                                    onClick={() => {
                                        setImgList((prev) => prev.map(({ img, photo }, j) => ({ img, photo, main: i === j })))
                                    }}
                                >Main</Button>}
                                actions={[
                                    <DeleteOutlined onClick={() => {
                                        setImgList(prev => prev.filter((v, j) => j !== i))
                                        if (main) {
                                            setImgList(prev => prev.map((v, j) => ({ ...v, main: j === 0 })))
                                        }
                                    }}
                                    />
                                ]}
                                style={{ width: "150px" }}
                                size='small'>
                                <Image width={"100%"} style={{ objectFit: "contain", objectPosition: "center" }} height={"100px"} src={
                                    // img
                                    `${BASE_URL}/file/${photo?.[photo.length - 1]?.file_id}`
                                } />
                                {!photo.length && <Alert type="error" message={"ERROR"} />}
                            </Card>
                        ))
                    }
                </Image.PreviewGroup>
                <Card size='small' style={{ width: "fit-content", height: "fit-content" }}>
                    <label style={{ height: "fit-content", display: "block", padding: "20px 30px" }}>
                        <input type="file" multiple style={{ display: "none" }}
                            onChange={async (e) => {
                                const files = e.target.files;
                                for (let i = 0; i < files.length; i++) {
                                    const file = files[i];
                                    const img = await getBase64(file);
                                    const formData = new FormData();
                                    formData.append("image", file);
                                    uploadFile.execute({
                                        data: formData, onSuccess: (res) => {
                                            setImgList(prev => [...prev, { img, photo: res.data, main: !prev.length }]);
                                        }
                                    })

                                }


                            }}
                        />
                        <CloudUploadOutlined style={{ fontSize: "50px" }} frameBorder />
                        <div>
                            Upload
                        </div>
                    </label>
                </Card>
            </Wrapper>
            {previewImage && (
                <Image
                    wrapperStyle={{
                        display: 'none',
                    }}
                    preview={{
                        visible: previewOpen,
                        onVisibleChange: (visible) => setPreviewOpen(visible),
                        afterOpenChange: (visible) => !visible && setPreviewImage(''),
                    }}
                    src={previewImage}
                />
            )}
        </>
    );
};
export default UploadImg;